export function pluralCs(n: number, one: string, few: string, many: string): string {
	if (n === 1) return one;
	if (n >= 2 && n <= 4) return few;
	return many;
}

export const strings = {
	nav: {
		openMenu: 'Otevřít menu',
		closeMenu: 'Zavřít menu',
		footerAriaLabel: 'Zápatí',
		reserve: 'Rezervovat',
	},
	footer: {
		rightsReserved: 'Všechna práva vyhrazena.',
		companyId: 'IČO:',
		documentsAriaLabel: 'Dokumenty ke stažení',
	},
	logo: {
		homeAriaLabel: 'PulseFit - domů',
		alt: 'PulseFit',
	},
	notFound: {
		seoTitle: 'Stránka nenalezena',
		seoDescription: 'Tato stránka neexistuje.',
		heading: 'Stránka nenalezena',
		body: 'Stránka, kterou hledáte, neexistuje nebo byla přesunuta.',
		backHome: 'Zpět na hlavní stránku',
	},
	dialog: {
		closeAriaLabel: 'Zavřít dialog',
	},
	starRating: {
		ratingAriaLabel: 'Hodnocení',
		starLabel: (n: number) => `${n} ${pluralCs(n, 'hvězdička', 'hvězdičky', 'hvězdiček')}`,
		outOfFive: (n: number) => `${n} z 5 hvězdiček`,
	},
	ctaBand: {
		or: 'nebo',
	},
	home: {
		logoIntroTagline: 'EMS osobní trénink | Plzeň',
		trainerPhotoAlt: 'Trenér PulseFit',
		trainerkaPhotoAlt: 'Trenérka PulseFit',
		featuresEyebrow: 'Co vás čeká',
		featuresHeading: 'EMS trénink nové generace bez přeplněné posilovny.',
		contraindicationsEyebrow: 'Než začnete',
		contraindicationsHeading: 'Kontraindikace',
		howItWorksEyebrow: 'Krok za krokem',
		testimonialsEyebrow: 'Reference',
		testimonialsHeading: 'Co říkají naši klienti',
		shareExperience: 'Sdílet svou zkušenost',
		testimonialsEmpty: 'Buďte první, kdo sdílí svou zkušenost!',
		seoTitle: 'EMS trénink Plzeň – individuální osobní trénink',
		seoDescription: (businessName: string, city: string) =>
			`Individuální EMS osobní trénink v ${city}. Jedna 20minutová lekce zapojí až 90 % svalů – zpevněte postavu, zhubněte a zlepšete kondici s certifikovaným trenérem studia ${businessName}.`,
	},
	services: {
		minutes: (n: number) => `${n} ${pluralCs(n, 'minuta', 'minuty', 'minut')}`,
		introEyebrow: 'EMS trénink',
		listEyebrow: 'Ceník',
		listHeading: 'Vyberte si svůj trénink',
		seoTitle: 'Ceník EMS tréninku v Plzni',
		seoDescription: (businessName: string, city: string) =>
			`Ceník a druhy EMS lekcí – ${businessName}, ${city}. Zkušební lekce, běžné tréninky i lekce ve dvojici. Individuální 20minutový trénink celého těla s osobním trenérem.`,
	},
	trainer: {
		seoTitle: 'Certifikovaní EMS trenéři',
		seoDescription: (businessName: string, city: string) =>
			`Poznejte certifikované EMS trenéry studia ${businessName} v ${city}. Každou lekci vedeme individuálně a přizpůsobíme intenzitu impulzů i výběr cviků vaší kondici a cílům.`,
	},
	recommendationDialog: {
		title: 'Sdílejte svou zkušenost',
		thankYouTitle: 'Děkujeme!',
		thankYouBody: 'Děkujeme za sdílení vaší zkušenosti - zkontrolujeme ji a brzy ji přidáme na web.',
		close: 'Zavřít',
		experienceLabel: 'Vaše zkušenost',
		nameLabel: 'Vaše jméno',
		ratingLabel: 'Vaše hodnocení',
		honeypotLabel: 'Toto pole nechte prázdné',
		reviewNote: 'Odeslané příspěvky procházejí kontrolou, než se zobrazí na webu.',
		ratingRequired: 'Vyberte prosím hodnocení.',
		genericError: 'Něco se pokazilo. Zkuste to prosím znovu.',
		networkError: 'Odeslání se nezdařilo. Zkuste to prosím znovu.',
		submit: 'Odeslat',
		submitting: 'Odesílání…',
	},
	contact: {
		mapTitle: 'Mapa s polohou studia',
		address: 'Adresa',
		getInTouch: 'Kontaktujte nás',
		followAlong: 'Sledujte nás',
		seoTitle: 'Kontakt – EMS studio Plzeň',
		seoDescription: (businessName: string, city: string) =>
			`Kontakt na EMS studio ${businessName} v ${city}. Domluvte si zvýhodněnou zkušební lekci, zeptejte se na EMS trénink nebo se zastavte – telefon, e-mail i mapa studia.`,
	},
} as const;
